import { render, staticRenderFns } from "./read-article-view.vue?vue&type=template&id=e78b95f4&scoped=true&"
import script from "./read-article-view.vue?vue&type=script&lang=js&"
export * from "./read-article-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78b95f4",
  null
  
)

export default component.exports